// extracted by mini-css-extract-plugin
module.exports = {"slider":"CustomSlider_slider__2IqZn","slick-next":"CustomSlider_slick-next__2lSky"};